import { Switch, Route } from "react-router-dom";

//auth pages
import ConfirmMail from "../views/User/Auth/ConfirmMail";
import LockScreen from "../views/User/Auth/LockScreen";
import SignIn from "../views/User/Auth/SignIn";

//ExtarPages
import Maintainance from "../views/Pages/Maintainance";
import Error404 from "../views/Pages/Error/Error404";
import Error500 from "../views/Pages/Error/Error500";
import CommingSoon from "../views/Pages/CommingSoon";

const ExtraPages = () => {
  return (
    <Switch>
      {/* auth */}
      <Route path="/auth/confirm-mail" component={ConfirmMail} />
      <Route path="/auth/lock-screen" component={LockScreen} />
      <Route path="/auth/sign-in" component={SignIn} />

      {/* ExtraPages */}
      <Route path="/extra-pages/pages-error" component={Error404} />
      <Route path="/extra-pages/pages-error-500" component={Error500} />
      <Route path="/extra-pages/pages-comingsoon" component={CommingSoon} />
      <Route path="/extra-pages/pages-maintenance" component={Maintainance} />
    </Switch>
  );
};

export default ExtraPages;
